import { Icon, Tooltip } from '@material-ui/core';
import React from 'react';

import type { Action } from 'v2/interfaces/access-control';

import { useStyles } from './styles';

const icons = {
  'ocultar-valores': 'visibility_off',
  visualizar: 'remove_red_eye',
  reembolsar: 'replay',
  editar: 'edit',
  'editar-produto': 'edit',
  'editar-campanha': 'edit',
  exportar: 'get_app',
  'exportar-resultado': 'get_app',
  'exportar-relatorio': 'get_app',
  'cancelar-contrato': 'cancel',
  'suspender-contrato': 'stop',
  'ver-dados-cliente': 'person',
  'ver-dados-clientes': 'person',
  'cadastrar-produto': 'add_circle',
  adm: 'supervisor_account',
  'entrega-manual': 'send',
  'arquivar-produto': 'delete_outline',
  'criar-campanha': 'add_circle',
  'solicitar-transferencia': 'attach_money',
  'solicitar-transferência': 'attach_money',
  'abrir-chamado': 'help',
  'chat-vip': 'chat',
  'gerenciar-cupons': 'local_offer',
  'negociar-faturas': 'attach_money',
  dashboard: 'dashboard',
  criar: 'add_circle',
};

type AccessPolicyIconProps = {
  action: Action;
};

function AccessPolicyIcon({ action }: AccessPolicyIconProps) {
  const classes = useStyles();
  const iconKey = action.fullname.split(':').pop();
  const icon = icons[iconKey];
  return (
    <Tooltip placement='top' title={action.name}>
      <Icon className={classes.icon}>{icon || 'help'}</Icon>
    </Tooltip>
  );
}

export { AccessPolicyIcon };
